import { ZEntityField } from "src/types/ZEntity";
import { ZUid } from "src/types/zUid";

export enum MassEditFieldsNames {
  attributeId = "attributeId",
  values = "values",
  clear = "clear",
}

export type MassEditFormData = {
  [MassEditFieldsNames.attributeId]: ZUid;
  [MassEditFieldsNames.values]: ZEntityField["values"];
  [MassEditFieldsNames.clear]: boolean;
};

export type MassEditRequestData = {
  entitiesIds: ZUid[];
  clear: boolean;
  attributeValue: ZEntityField;
};
